<template>
  <div class="HomeDialog">
    <div class="HomeDialog-header">
      <div>校内浮窗管理</div>
      <el-button type="primary" @click="handleAdd">新增</el-button>
    </div>
    <div class="HomeDialog-main" v-loading="loading">
      <el-form label-width="60px">
        <el-form-item label="状态">
          <el-select
            v-model="searchForm.status"
            placeholder="请选择"
            style="width: 200px"
            @change="bindStausChange"
          >
            <el-option
              v-for="(item, index) in statusOptions"
              :key="item.value"
              :label="item"
              :value="index + 1"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" border>
        <el-table-column prop="id" label="ID" align="center" />
        <el-table-column inline-template label="浮窗图" align="center">
          <div class="img-wrap">
            <img :src="row.imgUrl" alt="浮窗图" />
          </div>
        </el-table-column>
        <el-table-column inline-template label="浮窗收起图" align="center">
          <div class="img-wrap">
            <img :src="row.retractImgUrl" alt="浮窗收起图" />
          </div>
        </el-table-column>
        <el-table-column prop="name" label="标题" align="center" />
        <el-table-column prop="applySchool" label="应用学校" align="center" />
        <el-table-column prop="clockCount" label="本月点击次数" align="center" />
        <el-table-column
          prop="startTime"
          label="发布时间"
          align="center"
          width="170px"
        />
        <el-table-column
          prop="endTime"
          label="失效时间"
          align="center"
          width="170px"
        />
        <el-table-column
          label="最后操作"
          align="center"
          inline-template
          width="170px"
        >
          <div>
            <div>
              {{ row.updateName }}
            </div>
            <div>
              {{ row.updateTime }}
            </div>
          </div>
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          align="center"
          inline-template
        >
          <template>
            {{ statusOptions[row.status - 1] }}
          </template>
        </el-table-column>
        <el-table-column
          inline-template
          label="操作"
          width="200px"
          align="center"
        >
          <template>
            <el-button
              type="primary"
              size="small"
              title="查看"
              @click="handelDetail(row)"
            >
              查看
            </el-button>
            <el-button
              type="warning"
              size="small"
              title="置失效"
              v-if="row.status == 1"
              @click="handelCancel(row.id)"
            >
              置失效
            </el-button>
            <el-button
              type="info"
              size="small"
              title="编辑"
              v-if="row.status == 2"
              @click="handelEdit(row)"
            >
              编辑
            </el-button>
            <el-button
              type="success"
              size="small"
              title="发布"
              v-if="row.status == 2"
              @click="handelSubmit(row.id)"
            >
              发布
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="searchForm.pageNum"
          :page-size="searchForm.pageSize"
          layout="prev, pager, next, jumper"
          :total="tableTotal"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      searchForm: {
        status: 1,
        pageNum: 1,
        pageSize: 10,
      },
      statusOptions: ["已发布", "已失效"],
      tableData: [],
      tableTotal: 0,
    };
  },
  mounted() {
    this.apiPostTableData();
  },
  methods: {
    /**
     * 查询列表数据
     * @param status 状态 1 已发布 2 已失效
     * @param pageNum 当前页数
     * @param pageSize 每页数量
     */
    async apiPostTableData() {
      try {
        this.loading = true;
        this.tableData = [];
        const result = await this.$http({
          method: "POST",
          url: this.$util.domain + "/adminapi/v1/operate/floating/list",
          body: JSON.stringify({
            ...this.searchForm,
          }),
        });
        const { totalCount, list } = result.body.data;
        this.tableTotal = totalCount || 0;
        if (list && list.length) {
          this.tableData = list.map((item) => ({
            ...item,
            applySchool:
              item.allUnidFlag > 0 ? `${item.allUnidFlag}所学校` : "全部",
          }));
        }
      } catch (error) {
        this.tableData = [];
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    /**
     * 切换页数
     */
    handleCurrentChange(val) {
      this.searchForm.pageNum = val;
      this.apiPostTableData();
    },
    /**
     * 切换状态
     */
    bindStausChange(value) {
      this.searchForm = {
        status: value,
        pageNum: 1,
        pageSize: 10,
      };
      this.apiPostTableData();
    },
    /**
     * 新增
     */
    handleAdd() {
      this.$router.push({
        path: "/yunying/advert/HomeDialog/Detail",
        query: {
          isDetail: 0,
        },
      });
    },
    /**
     * 编辑
     */
    handelEdit(row) {
      this.$router.push({
        path: "/yunying/advert/HomeDialog/Detail",
        query: {
          isDetail: 0,
          floatingId: row.id,
          clockCount: row.clockCount || 0,
        },
      });
    },
    /**
     * 查看详情
     */
    handelDetail(row) {
      this.$router.push({
        path: "/yunying/advert/HomeDialog/Detail",
        query: {
          isDetail: 1,
          floatingId: row.id,
          clockCount: row.clockCount || 0,
        },
      });
    },
    /**
     * 发布
     */
    handelSubmit(id) {
      this.$confirm("是否确定重新发布？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.apiPostUpdateStatus({ id, status: 1 });
        })
        .catch(() => {});
    },
    /**
     * 置失效
     */
    handelCancel(id) {
      this.$confirm("是否确定置失效？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.apiPostUpdateStatus({ id, status: 2 });
        })
        .catch(() => {});
    },
    /**
     * 撤销或发布
     * @param status 状态 1 发布 2 失效
     * @param id 浮窗id
     */
    async apiPostUpdateStatus(params) {
      try {
        const result = await this.$http({
          method: "POST",
          url: this.$util.domain + "/adminapi/v1/operate/floating/updateStatus",
          body: JSON.stringify({
            ...params,
          }),
        });
        if (result.body.error == 10000) {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.apiPostTableData();
        } else {
          this.$message({
            type: "error",
            message: result.body.message,
          });
        }
      } catch (error) {
        console.log(error, "///////////");
        this.$message({
          type: "error",
          message: "操作失败",
        });
      }
    },
  },
};
</script>

<style scoped>
.HomeDialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #eee;
  font-size: 16px;
  padding: 0 10px 0 30px;
  margin: 20px 0;
}
.HomeDialog-main {
  padding: 0 10px;
}
.img-wrap {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.img-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px 0;
}
.img-wrap img {
  width: 100px;
  height: 100px;
  object-fit: contain;
}
</style>


// WEBPACK FOOTER //
// index.vue?14fc723e